export const searchIndices = [
    { name: `Posts`, title: `Blog Posts`, hitComp: `PostHit` },
    { name: `Projects`, title: `Projects`, hitComp: `ProjectHit` },
    { name: `Resources`, title: `Resources`, hitComp: `ResourceHit` }
];